export default "/_next/static/videos/actionsen-30264a7efc9900965a6271a7ecc3cc56.mp4";